"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var lib_1 = require("../lib");
var ProjectFixedDates_1 = require("./ProjectFixedDates");
var ProjectFlexiDates_1 = require("./ProjectFlexiDates");
var CartProvider_1 = require("./CartProvider");
var i18n_1 = require("@wordpress/i18n");
var compat_1 = require("preact/compat");
var padWithZeros = function (num, length) {
    var str = '' + num;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
};
var getReturnDate = function (startDate, durationDays, format) {
    if (!durationDays) {
        return '';
    }
    durationDays = durationDays - 1; //Duration needs to be inclusive of start date
    var newStartDate = new Date((0, lib_1.setDateStringToMidnight)(startDate));
    newStartDate.setDate(newStartDate.getDate() + durationDays);
    var ms = newStartDate.getTime();
    return format ? (0, lib_1.formatDate)(ms) : ms;
};
var doesOverlapExistingTrip = function (date, returnDateMs, cart) {
    var dayInMs = 86400000;
    var returnDate = returnDateMs ? new Date(returnDateMs).getTime() : false;
    var inputDate = new Date((0, lib_1.setDateStringToMidnight)(date)).getTime();
    var overlapsExistingTrip = false;
    for (var _i = 0, cart_1 = cart; _i < cart_1.length; _i++) {
        var cartItem = cart_1[_i];
        var cartItemStartDate = new Date((0, lib_1.setDateStringToMidnight)(cartItem.startDate)).getTime();
        var cartItemEndDate = new Date((0, lib_1.setDateStringToMidnight)(cartItem.endDate)).getTime();
        var isInvalidStartDate = inputDate > cartItemStartDate && inputDate <= cartItemEndDate;
        var isInvalidEndDate = returnDate && (returnDate + dayInMs) > cartItemStartDate && inputDate <= cartItemEndDate;
        if (isInvalidStartDate || isInvalidEndDate) {
            overlapsExistingTrip = true;
            break;
        }
    }
    return overlapsExistingTrip;
};
var getSuggestedStartDateString = function () {
    var suggestedStartDate = null;
    var suggestedStartElement = document.querySelector('[data-next-suggested-start-date]');
    var startDateAttribute = suggestedStartElement ? suggestedStartElement.getAttribute('data-next-suggested-start-date') : '';
    if (startDateAttribute.length) {
        var suggestedStartDateObject = new Date((0, lib_1.setDateStringToMidnight)(startDateAttribute));
        var day = padWithZeros(suggestedStartDateObject.getDate(), 2);
        var month = padWithZeros(suggestedStartDateObject.getMonth() + 1, 2);
        var year = suggestedStartDateObject.getFullYear().toString();
        suggestedStartDate = "".concat(year, "-").concat(month, "-").concat(day);
    }
    return suggestedStartDate;
};
var formatStartDate = function (dateString) {
    if (!dateString || dateString === '') {
        return '';
    }
    // values are padded with zeros to match
    // the iso format
    var date = new Date((0, lib_1.setDateStringToMidnight)(dateString));
    var day = padWithZeros(date.getDate(), 2);
    var month = padWithZeros(date.getMonth() + 1, 2);
    var year = date.getFullYear().toString();
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var formatFlexiDate = function (dateString) {
    if (!dateString || dateString === '') {
        return { day: '', month: '', year: '' };
    }
    // Values not padded with zeros to match
    // the format of the select options
    var date = new Date((0, lib_1.setDateStringToMidnight)(dateString));
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return {
        day: day.toString(),
        month: month.toString(),
        year: year.toString()
    };
};
var checkValidStartDate = function (dateString, durationDays, cart) {
    var inputDate = new Date((0, lib_1.setDateStringToMidnight)(dateString));
    var now = new Date();
    var isFuture = inputDate.getTime() > now.getTime();
    var returnDate = getReturnDate(dateString, durationDays, false);
    return dateString && isFuture && !doesOverlapExistingTrip(dateString, returnDate, cart);
};
var ProjectDates = (0, compat_1.forwardRef)(function ProjectDates(props, ref) {
    var project = props.project, isValid = props.isValid, setIsValid = props.setIsValid, defaultStartDate = props.defaultStartDate, defaultDurationDays = props.defaultDurationDays, onMount = props.onMount;
    (0, hooks_1.useEffect)(function () {
        if (typeof onMount === 'function') {
            onMount(ref);
        }
    });
    // If we have a default start date from the URL params we use it,
    // else, for flexi-date projects, we use a calcualted, suggested start date based on the items in the cart
    var isFixedDateProject = project && project.isFixedDateProject;
    var updatedDefaultStartDate = isFixedDateProject || defaultStartDate ? defaultStartDate : getSuggestedStartDateString();
    var _a = (0, hooks_1.useState)(defaultDurationDays), durationDays = _a[0], setDurationDays = _a[1];
    var _b = (0, hooks_1.useState)(formatStartDate(updatedDefaultStartDate)), startDate = _b[0], setStartDate = _b[1];
    var _c = (0, hooks_1.useState)(formatFlexiDate(updatedDefaultStartDate)), flexiDate = _c[0], setFlexiDate = _c[1];
    var _d = (0, hooks_1.useState)(false), isStartDateValid = _d[0], setIsStartDateValid = _d[1];
    var cart = (0, hooks_1.useContext)(CartProvider_1.CartContext).cart;
    (0, hooks_1.useEffect)(function () {
        // If the flexi start date is incomplete we do not show the error message, which would otherwise show too early
        // But we do not set the form as valid until it has been set so that the user cannot submit the form
        var isFlexiStartDateIncomplete = !isFixedDateProject &&
            (flexiDate.day === '' || flexiDate.month === '' || flexiDate.year === '');
        var isStartDateValidNew = startDate !== "" && checkValidStartDate(startDate, durationDays, cart);
        setIsStartDateValid(isStartDateValidNew || isFlexiStartDateIncomplete);
        var isDurationValidNew = durationDays !== "";
        setIsValid(isStartDateValidNew && isDurationValidNew);
    }, [durationDays, startDate, flexiDate, cart, setIsStartDateValid, setIsValid]);
    (0, hooks_1.useEffect)(function () {
        if (isFixedDateProject) {
            return;
        }
        var day = flexiDate.day, month = flexiDate.month, year = flexiDate.year;
        var isMissingField = day === '' || month === '' || year === '';
        if (isMissingField) {
            setStartDate('');
        }
        else {
            setStartDate("".concat(year, "-").concat(padWithZeros(month, 2), "-").concat(padWithZeros(day, 2)));
        }
    }, [flexiDate, setStartDate]);
    var handleSetStartDate = function (newDateString) {
        setStartDate(formatStartDate(newDateString));
    };
    var hasFixedDates = project && project.fixedDates && project.fixedDates.length > 0;
    var returnDate = getReturnDate(startDate, durationDays, true);
    var errorClass = (!isStartDateValid) ? 'has-error' : '';
    var fixedDatesClass = (hasFixedDates) ? 'appform-field--startdate-fixed' : '';
    return (project && ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref, className: "appform-field--startdate appform-field--date-selector ".concat(fixedDatesClass, " ").concat(errorClass) }, { children: [!isFixedDateProject && ((0, jsx_runtime_1.jsx)(ProjectFlexiDates_1.default, { durations: project.durations || [], flexiDate: flexiDate, durationDays: durationDays, setFlexiDate: setFlexiDate, setDurationDays: setDurationDays })), isFixedDateProject && hasFixedDates && ((0, jsx_runtime_1.jsx)(ProjectFixedDates_1.default, { startDateString: startDate, durationDays: durationDays, fixedDates: project.fixedDates, setStartDate: handleSetStartDate, setDurationDays: setDurationDays })), !isStartDateValid && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-field__label--error" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "project_option_has_error", value: "1" }), (0, i18n_1.__)("Please check these dates. You have either entered a start date that is in the past, or you have selected a date that conflicts with the project(s) already in your shopping cart.", "projects-abroad")] }))), isValid && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-destination-details__return-date" }, { children: [(0, i18n_1.__)("End date", "projects-abroad"), ": ", (0, jsx_runtime_1.jsx)("strong", { children: returnDate ? returnDate : 'Invalid date' }), (0, jsx_runtime_1.jsx)("br", {}), (0, i18n_1.__)("Based on your start date +", "projects-abroad"), " ", (0, lib_1.getDurationLabel)(durationDays)] })))] }))));
});
exports.default = ProjectDates;
